module.exports = __webpack_public_path__ + "8b6d7350235e3e5bd8cb33eca40e60c2.svg";